import { finish, error } from '../../../modules/participants/actions/query';
import api from '../../../api';

export function request(dispatch, action) {
    const query = action.query;
    let requestBody = {};
    if (query !== undefined) {
        requestBody = {
            ngram: query['name.ngram'],
            sport: query.sport,
            prefix: query.prefix,
            name: query.name
        };
    }
    $appState.sdkStaff.getParticipants({
        requestBody
    }).then( data => {
        return dispatch(finish(action.id, data));
    }).catch( errors => dispatch(error(action.id, errors)));
    
    // api.get('/participants', action.query, { cache: true }).then(
    //     (participants) => dispatch(finish(action.id, participants)),
    //     ({ errors }) => dispatch(error(action.id, errors))
    // );
}
